import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { ResidenceCountry } from '@lx/shared/data-access/destination';
import { DropdownModule } from 'primeng/dropdown';
import { getCustomFormComponentControlValueAccessorProvider } from '@lx/quote-tool/lite/shared/utils';
import { ResidenceDataService } from '../../services';
import { DropdownSidePanelFieldComponent } from '@lx/quote-tool/lite/shared/ui/components';
import { SelectorField } from '@lx/quote-tool/lite/shared/ui/directives';

@Component({
  standalone: true,
  selector: 'lx-residence-country-selector',
  templateUrl: './residence-country-selector.component.html',
  styleUrls: ['./residence-country-selector.component.scss'],
  imports: [DropdownModule, FormsModule, DropdownSidePanelFieldComponent],
  providers: [getCustomFormComponentControlValueAccessorProvider(ResidenceCountrySelectorComponent)],
})
export class ResidenceCountrySelectorComponent extends SelectorField<string> implements OnInit {
  @Input() title: string;
  residenceCountries: ResidenceCountry[] | undefined;

  private readonly destroyRef = inject(DestroyRef);
  private readonly residenceDataService = inject(ResidenceDataService);

  ngOnInit() {
    this.residenceDataService
      .loadResidenceCountries()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((residenceCountries: ResidenceCountry[]) => {
        this.residenceCountries = residenceCountries;
      });
  }
}
